import moment from "moment";

export default class ObjectUtil {

    // https://stackoverflow.com/questions/728360/how-do-i-correctly-clone-a-javascript-object/728694#728694
    static clone(obj) {
        var copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj)
            return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date(obj.getTime());
            return copy;
        }

        // Handle Moment
        if (obj instanceof moment) {
            copy = moment(obj);
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0; i < obj.length; i++) {
                copy[i] = ObjectUtil.clone(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = ObjectUtil.clone(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    static sort(arr, field) {
        if (!arr || !Array.isArray(arr) || arr.length === 0) {
            return arr;
        }

        return arr.sort((a, b) => {
            const fieldA = a[field];
            const fieldB = b[field];

            if (fieldA < fieldB) {
                return -1;

            } else if (fieldA > fieldB) {
                return 1;
            }

            return 0;
        });
    }

    static get(obj, propertyPath) {
        if (obj === null || obj === undefined
            || propertyPath === null || propertyPath === undefined || propertyPath === "") {
            return obj;
        }

        let result = obj;
        for (const property of propertyPath.trim().split(".")) {
            result = result[property];
            if (result === null || result === undefined) {
                return undefined;
            }
        }

        return result;
    }

    static set(obj, propertyPathArray, value) {
        if (obj === null || obj === undefined
            || propertyPathArray === null || propertyPathArray === undefined || propertyPathArray.length === 0) {
            return obj;
        }

        let iterator = obj;
        for (let i = 0; i < propertyPathArray.length; i++) {
            const path = propertyPathArray[i];
            if (i === propertyPathArray.length - 1) {
                iterator[path] = value;
            } else if (!iterator[path]) {
                iterator[path] = {};
            }
            iterator = iterator[path];
        }
    }

}